import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = typeof window !== "undefined" ? localStorage.getItem("ch_token") : null;
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;

export function fileUrl(storagePathOrUrl) {
    if (!storagePathOrUrl) return "";
    if (storagePathOrUrl.startsWith("http")) return storagePathOrUrl;
    if (storagePathOrUrl.startsWith("/api/files/")) return `${BACKEND_URL}${storagePathOrUrl}`;
    return storagePathOrUrl;
}
